import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listMeasurements = async ({
    userRoleUuid,
    subjectRoleUuid,
    measurementTypes,
    queryTs,
    order,
    paginationLimit,
    paginationToken
} = {}) =>
    api.get('/measurements', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(subjectRoleUuid ? { 'CVP-QUERY-SUBJECT': subjectRoleUuid } : {}),
            ...(Array.isArray(measurementTypes) && measurementTypes.length > 0
                ? { 'CVP-QUERY-MEASUREMENT-TYPE': JSON.stringify(measurementTypes) }
                : {}),
            ...(queryTs ? { 'CVP-QUERY-TS': queryTs } : {}),
            ...(order ? { 'CVP-QUERY-ORDER': order } : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': paginationLimit } : {}),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {})
        }
    });

export const fetchMeasurement = async ({ userRoleUuid, measurementUuid } = {}) =>
    api.post(
        '/measurements/fetch',
        { measurement: measurementUuid },
        {
            headers: {
                ...makeRoleHeaders(userRoleUuid)
            }
        }
    );

export const createMeasurement = async ({
    userRoleUuid,
    subjectRoleUuid,
    dtype,
    data,
    ts
} = {}) =>
    api.post(
        '/upload/measurement',
        {
            ts: ts || new Date().toISOString(),
            dtype,
            data,
            subject: subjectRoleUuid
        },
        {
            headers: {
                ...makeRoleHeaders(userRoleUuid)
            }
        }
    );
